// Material
import {
  Divider,
  ListItemButton,
  SxProps,
  TypographyProps,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ForwardedRef, forwardRef, ReactElement } from 'react'

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  width: '100%',
  minHeight: '66px',

  margin: 0,
  padding: '8px 16px',

  outline: 'none',
  textAlign: 'inherit',
  backgroundColor: theme.palette.white,
  flexGrow: 0,
  gap: '4px',
  // '.Mui-disabled': {
  //   backgroundColor: 'red',
  //   display: 'none',
  // },
  '&.Mui-disabled': {
    opacity: 1,
  },
}))

const ListItemButtonInnerWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`

const StyledDivider = styled(Divider)`
  margin-right: 48px;
  &:last-child {
    display: none;
  }
`

interface Props {
  primaryText: string | ReactElement
  primaryTextColor?: TypographyProps['color']
  primaryTextVariant?: TypographyProps['variant']
  secondaryText: string | ReactElement
  secondaryTextColor?: TypographyProps['color']
  secondaryTextVariant?: TypographyProps['variant']
  icon: JSX.Element
  primaryIcon?: JSX.Element
  onClick: () => any
  className?: string
  primaryTextBadge?: JSX.Element
  disabled?: boolean
  sx?: SxProps
}

export const OptionWithTextItem = forwardRef(function OptionWithTextItem(
  {
    primaryIcon,
    primaryText,
    primaryTextColor,
    primaryTextVariant,
    secondaryText,
    secondaryTextColor,
    secondaryTextVariant,
    icon,
    onClick,
    className,
    primaryTextBadge,
    disabled,
    sx,
  }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <>
      <StyledListItemButton
        sx={sx}
        ref={ref}
        className={className}
        onClick={onClick}
        disabled={disabled}
      >
        <ListItemButtonInnerWrapper>
          {primaryIcon && <IconWrapper>{primaryIcon}</IconWrapper>}

          <TextWrapper>
            {typeof primaryText === 'string' ? (
              <Typography
                variant={primaryTextVariant || 'body2'}
                component="div"
                sx={{ display: 'flex', gap: '4px' }}
                color={primaryTextColor || 'secondary700'}
              >
                {primaryText}
                {primaryTextBadge}
              </Typography>
            ) : (
              primaryText
            )}

            {typeof secondaryText === 'string' ? (
              <Typography
                dir="auto"
                variant={secondaryTextVariant || 'body2'}
                color={secondaryTextColor || 'neutral900'}
              >
                {secondaryText}
              </Typography>
            ) : (
              secondaryText
            )}
          </TextWrapper>

          {icon && (
            <IconWrapper style={{ alignSelf: 'center', marginLeft: 0 }}>
              {icon}
            </IconWrapper>
          )}
        </ListItemButtonInnerWrapper>
      </StyledListItemButton>
      <StyledDivider />
    </>
  )
})

const TextWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const IconWrapper = styled('div')`
  align-self: start;
  width: fit-content;
  height: fit-content;
  margin-left: 4px;
`
